<template>
  <div class="report">
    <!-- 顶部 -->
    <oa-frame-nav
      :perviousUrl="1"
      :onlyBlackShow="true"
      v-if="navShow"
    ></oa-frame-nav>
    <!-- 内容 -->
    <div class="center" v-if="!toSmsVerifi" :style="handleStyleTemp">
      <custom-loading :loading="isLoading" :isFullScreen="false"></custom-loading>
      <div class="right" :style="styleTemp && styleTemp.region ? 'max-width:1440px;margin-left:auto;margin-right:auto;' : ''">
        <div
          ref="rightDrage"
          :class="reportClickSta ? 'right-drage hide' : 'right-drage'"
          :style="[{overflowX: styleTemp.canvasConfig && styleTemp.canvasConfig.layout === 0 && styleTemp.canvasConfig.canvasType === 1 ? 'auto' : 'hidden'}, addUpRevise && addUpRevise.i ? {height:'calc(100% - 52px)'} : '']"
          @click="reportClick"
        >
          <!-- addGrid 添加节点 -->
          <gridDrage
            class="grid-box"
            ref="gridDrages"
            :id="approvalReportId"
            :style="bgstyle"
						:seriesType="seriesType"
            :theme="styleTemp.themeValue || {}"
            :draggable="false"
            :disabled="false"
            :resizable="false"
            :isFrontEnd="false"
            :styleTemp="styleTemp"
            :organizationType="organizationType"
            :customDeskInfo="customDeskInfo"
            :addUpRevise="addUpRevise"
            @endStatus="$emit('close')"
            @upSummaryInst="upSummaryInst"
            @downloadInfo="downloadInfo"
            @openAppInitiate="openAppInitiate"
          />
        </div>
        <div v-if="addUpRevise && addUpRevise.i" class="revise">
          <el-button size="small" @click="closeButton()">取消</el-button>
          <el-button size="small" type="primary" @click.stop="upSummary()">保存</el-button>
        </div>
      </div>
    </div>
    <!-- 仪表盘客户端验证过滤 -->
    <verification-and-queryinput
      ref="VerificationAndQueryInputRef"
      :approvalId="approvalReportId"
      :number="4"
      @toVerificationAndQuery="formVerificationAndQuery"
      v-if="VerAndInputShow"
    ></verification-and-queryinput>
    <smsVerifiction
      ref="smsVerifi"
      :approvalId="approvalReportId"
      v-show="toSmsVerifi"
      @smsRefersh="smsRefersh"
    />
    <!-- 发起 -->
    <app-dialog
      :dialogInfo="{
        dialogName: openInput.name,
        isVisible: openInput.isVisible,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        childDialog: true
      }"
      :iId="openInput.iId"
      v-model:isDetail="openInput.isDetail"
      :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow"
      :coverVal="openInput.search"
      :datatype="openInput.datatype"
      @doorUp="doorUp"
      @close="doorUpCloe" />
    <el-dialog v-model="isShowSucloading" append-to-body :close-on-press-escape="false" :show-close="false" class="noSuccess">
      <Success-loading :show="isShowSucloading" :animationStyle="animationStyle" :isInstrument="true" />
    </el-dialog>
    <div v-html="styleClassFun()"></div>
    <vipPay v-model:isView="vipPayShow" />
  </div>
</template>

<script>
// 引入基本模板
import { returnAllTopStyle } from '@/api/styleUtils'
import { axiosBase } from '@/api/api'
import gridDrage from './common/drageGrid.vue'//- 拖拽组件
import { screeningRules } from '@/api/instrumentControl';//- 仪表盘筛选组件，获取本身设置规则数据
import verificationAndQueryinput from '@/components/clientSide/VerificationAndQueryInput.vue'
import { apiValidateapprovaldashboardsms } from '@/port/clientSide/workbench'
import smsVerifiction from '@/components/clientSide/common/smsVerifiction.vue'
import { getapprovalbindval, getdeptlist } from "@/port/admins/instrument";
import { fileWhere } from "@/api/drageControl";
import { getdepttiplist } from "@/port/admins/organizationUser";
import { getTimeInstrument } from '@/api/instrumentControl.js'
import { getFilterValue, getFilterBindField } from '@//util/customData.js'
import { cloneDeep } from 'lodash';
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins.js'
import { defineAsyncComponent } from 'vue';

export default {
  name: 'instrumentClide',
  mixins: [parmsMixins],
  components: {
    oaFrameNav: defineAsyncComponent(() => import('@/components/clientSide/oaFrame/oaFrameCommon/oaFrameNav.vue')),
    AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
    gridDrage,
    verificationAndQueryinput,
    smsVerifiction,
    SuccessLoading: defineAsyncComponent(() => import('@/components/common/successLoading.vue')),
    vipPay: defineAsyncComponent(() => import('@/components/common/vipPay/index')),
  },
  props:{
    customDeskInfo:{
      type: Object,
      default: ()=> ({})
    },
  },
  provide: {
    isFrontEnd: false,
    mobile: {
      isMobile: false
    },
    allDatasArray: {}
  },
  data () {
    return {
      approvalReportId: '',//- 仪表盘id
      categoryId: '',
      organizationType: [],
      //- 最后要提交的仪表盘数据
      submitDataAlls: {
        approvalDashboardId: '',//- 仪表盘id（用户第二次修改仪表盘需要传递参数）
        appname: '',//- 仪表盘名称
        description: '',//- 仪表盘描述
        categoryId: '',//- 分组
        status: 1,//- 状态(默认都是1)
        orders: '',//- 排序
        icon: '',//- 图标
        config: [],//- 配置信息(重要参数)
      },
      grid: [],
      type: '',//- 根据不同的type打开不同设置页面的开关按钮
      reportClickSta: false,//- true:当前仪表盘里的筛选组件获得焦点后，页面不行滚动
      VerAndInputShow: false,//- 仪表盘验证过滤显示
      VerAndInputDatas: [],//- 仪表盘前台验证数据

      toSmsVerifi: true, // 是否打开短信验证
      isSmsButton: '', // 是否点击了下载按钮
      isSmsFun: false, // 是否验证过了
      navShow: false,//- nav导航是否展示
      // 过来打开单个并带参数搜索的
      search: null,

      // 打开应用
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      },
      openAddInputShow: false, // 发起单独使用的
      // 背景样式相关内容
      styleTemp:{
        radio:'default',
        color:'#fff',
        image:'',
        imgUrl:'',
        absorb:'open',
        region: false
      },
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      vipPayShow: false, //会员支付
			seriesType:'value',// 系列类型
      isShowSucloading: false,
      animationStyle: {
        animationList: [{
          name:"样式一",
          text:"保存成功",
          value:0
        }],
        value:0
      },
      addUpRevise: {},
      resizeTimeout: null,
      scaleNum: 1,
      paramsSearch: {}, // 变量传筛选的接收
      svg:`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-v-ea893728="">
        <path
          d="M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z" 
          style="stroke-width: 4px; fill: #409EFF"
        />
        </svg>`,
      isLoading: false
    }
  },
  created () {
    let query = this.$route.query
    this.paramsSearch = {}
    if (Object.keys(this.customDeskInfo).length !== 0) {
      query = {
        ...query,
        ...this.customDeskInfo
      }
      if (this.customDeskInfo.paramsList) {
        const paramsArr = typeof this.customDeskInfo.paramsList === 'string' ? JSON.parse(this.customDeskInfo.paramsList) : this.customDeskInfo.paramsList
        paramsArr.forEach(item => {
          // eslint-disable-next-line no-unused-vars
          const [ name, title, type ] = item.name.split('_')
          if (type === 'Sizer') {
            this.paramsSearch[title] = item.value
          }
        })
      }
    }
    const spaceId = query.spaceid
    const spaceStatus = query.space
    const upaceId = query.upaceid
    const upaceStatus = query.upace
    if (query.token) {
      sessionStorage.setItem('temporaryToken', query.token)
    }
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
    this.getOrganizationType()
    let categoryId = query.categoryId;//- 应用id（后端要的参数，由上一页带入）
    this.approvalReportId = query.dataReportId;//- 仪表盘id（为第二次进来后展示数据用）
    this.submitDataAlls.categoryId = categoryId;
    // 搜索相关
    if (query.search) {
      const search = JSON.parse(query.search)
      if (query.showSearch) {
        // 联系人值直接转掉(叶子确认，联系人过来不转)
        this.search = search
      } else {
        this.search = {
          rules: search.rules || [],
          relevanceRules: search.relevanceRules || [],
          i: query.showId
        }
      }
    }
    if (this.approvalReportId && this.approvalReportId != '') {
      //- 增加仪表盘验证判断
      this.VerAndInputShow = true;
      this.instrumentList();
    }
    if (query.navShow) {
      let navShow = query.navShow;
      if(typeof navShow === 'boolean'){
        this.navShow = navShow
      }else if(typeof navShow === 'string'){
        if(navShow === 'true'){
          this.navShow = true
        }else if(navShow === 'false'){
          this.navShow = false
        }

      }
    }
    setTimeout(() => {
      window.addEventListener('resize', this.listenResize);
    }, 100)
  },
  unmounted () {
    const temporaryToken = sessionStorage.getItem('temporaryToken')
    if (temporaryToken) sessionStorage.removeItem('temporaryToken')
    window.removeEventListener('resize', this.listenResize);

  },
  computed:{
    handleStyleTemp(){
      let style = null
      if (this.styleTemp.radio === 'color') {
        style = {
          backgroundColor:this.styleTemp.color
        }
      }else if (this.styleTemp.radio === 'image') {
        style = {
          backgroundImage: `url(${this.$imgurl + this.styleTemp.image})`,
        }
      }else if (this.styleTemp.radio === 'link') {
        style = {
          backgroundImage: `url(${this.styleTemp.imgUrl})`,
        }
      }
      return style
    },
    bgstyle () {
      const obj = {
        margin: '0 auto',
        transformOrigin: 'left top'
      }
      if (this.styleTemp.canvasConfig) {
        const canvasConfig = this.styleTemp.canvasConfig
        obj.width = canvasConfig.canvasType === 1 ? canvasConfig.canvasSize.width + 'px' : '100%'
        obj.height = canvasConfig.canvasType === 1 ? canvasConfig.canvasSize.height + 'px' : '100%'
        if (canvasConfig.layout === 1 && canvasConfig.canvasType === 1) {
          obj.transform = `scale(${this.scaleNum})`
          obj.margin = '0'
        }
      }
      return obj 
    },
  },
  watch: {
    'styleTemp.canvasConfig.layout': {
      handler (val) {
        if (val === 1 && this.styleTemp.canvasConfig.canvasType === 1) {
          const boxWidth = this.$refs.rightDrage.offsetWidth
          const canvasWidth = this.styleTemp.canvasConfig.canvasSize.width
          this.scaleNum = boxWidth / canvasWidth
        }
      },
      immediate: true
    }
  },
  methods: {
    listenResize () {
      clearTimeout(this.resizeTimeout);
      const that = this
      this.resizeTimeout = setTimeout(function() {
          that.getScale()
      }, 250); 
    },
    async getScale () {
      this.$nextTick(() => {
        if (this.$refs.rightDrage) {
          var width = this.$refs.rightDrage.clientWidth;
          this.scaleNum = (width / this.styleTemp.canvasConfig.canvasSize.width).toFixed(4)
        }
      })
    },
    closeButton () {
      this.$refs.gridDrages.closeButton(this.addUpRevise.i)
    },
    upSummary () {
      this.$refs.gridDrages.upSummary({ uId: this.addUpRevise.i, i: this.addUpRevise.ii })
    },
    upSummaryInst ({ key, config }) {
      this[key] = config
    },
    async getOrganizationType () {
      // 组织类型
      const { data, code, msg } = await getdepttiplist({
        curpage: 1,
        pagesize: 9999
      })
      if (code === 0) {
        this.organizationType = data
      } else {
        this.$message.error(msg)
      }
    },
    doorUpCloe () {
      this.openInput = {
        isVisible: false,
          approvalId: '',
          search: {},
        iId: ''
      }
      // this.openInput.isVisible = false
    },
    doorUp () {
      console.log('提交回来刷新', this.openInput)
      // 提交回来去刷新
      if (this.openInput.id) {
        const gridDrages = this.$refs.gridDrages
        const index = gridDrages._data.layout.findIndex(its => its.i === this.openInput.id)
        console.log('刷新匹配查询', index, this.customDeskInfo)
        if (index !== -1) {
          const item = gridDrages._data.layout[index]
          if (item.type === 'detailed') {
            gridDrages.getNewFromDatas(index, item, gridDrages._data.drawer)
          }
        }
      }
    },
    // 点击过来进入发起
    openAppInitiate ({approvalId, name, search, iId, id, datatype}) {
      const obs = {
        isVisible: true,
        approvalId: approvalId,
        name: name,
        search: search,
        iId: iId,
        isDetail: datatype === 5 ? false : iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
        id: id || '',
        datatype: datatype
      }
      this.openInput = obs
      this.openAddInputShow = iId === 11
    },
    // 下载按钮来验证
    downloadInfo (e) {
      if (this.isSmsFun) {
        // 之前验证过了，直接调用结果按钮
        this.$nextTick(() => {
          this.$refs.gridDrages.download(e);
        })
        return false;
      }
      this.isSmsButton = e;
      this.smsVerifi(2);
    },
    //- 仪表盘·获取列表
    instrumentList () {
      const obj = { approvalDashboardId: this.approvalReportId };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      axiosBase(obj, "/api/validateapprovaldashboard").then(res => {
        if (res.code === 0) {
          if (!res.data.validatequery && !res.data.filter) {
            // 进行短信验证
            this.smsVerifi(1);
          } else {
            this.$refs.VerificationAndQueryInputRef.instrumentList(res)
          }

        } else {
          console.log('getapproval 接口出错')
        }
      })
    },
    smsRefersh () {
      if (this.isSmsButton) {
        // 点击了按钮的
        this.isSmsFun = true;
        // 这里需要触发下载方法
        this.$nextTick(() => {
          this.$refs.gridDrages.download(this.isSmsButton);
          this.isSmsButton = '';
        })
      } else {
        this.toSmsVerifi = false;
        this.isLoading = true;
        this.secondShow(this.approvalReportId);
      }
    },
    smsVerifi (key) {
      let obj = {
        approvalDashboardId: this.approvalReportId,
        number: key   // 1:访问仪表盘；2：相关表盘导出数据
      };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      apiValidateapprovaldashboardsms(obj).then(res => {
        if (res.code === 0) {
          // bindcode 是否需要绑定手机号 smsverification 是否需要短信验证 phone 手机号
          if (res.data.smsverification && res.data.bindcode && !res.data.phone) {
            // 去绑定手机号
            if (this.isSmsButton === '') this.toSmsVerifi = true;
            this.$nextTick(() => {
              this.$refs.smsVerifi.iphoneBind({ isSmsView: true });
            })
          } else if (res.data.smsverification && res.data.phone) {
            // 去验证
            if (this.isSmsButton === '') this.toSmsVerifi = true;
            this.$nextTick(() => {
              this.$refs.smsVerifi.openSmsVer(res.data.phone, this.toSmsVerifi ? { isSmsView: true } : '');
            })
          } else {
            // 不需要验证
            if (key !== 1) {
              // 执行下载方法
              this.$nextTick(() => {
                this.$refs.gridDrages.download(this.isSmsButton);
              })
            } else {
              this.isLoading = true;
              this.toSmsVerifi = false;
              this.secondShow(this.approvalReportId);
            }
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    //- 仪表盘客户端验证过滤回调
    formVerificationAndQuery (res) {
      this.VerAndInputDatas = res;
      // 去验证短信二次验证
      this.smsVerifi(1);
    },
    //- 当前仪表盘里的筛选组件获得焦点后，页面不行滚动
    reportClick () {
      if (this.reportClickSta === true) {
        this.reportClickSta = false;
      }
    },
    //- 更新表数据，获取筛选器规则内容
    async getFormOrUpdateSize (config, key) {
      const that = this;
      for (let i = 0; i < config.length; i++) {
        const item = config[i]
        // 隐藏和初始化容器里面的不获取数据
        if (item.viewShow || item.isContainer && key) continue;
        if (item.type === 'Sizer' && !item.isContainer) {
          if (['status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(item.FilterField.type) !== -1 && item.activeName == 'select' && item.w >= 4 && item.h >= 22) {
            //- 说明是文本属性需要查找新的文本数据(产品新提需求：只有扩大样式的文本筛选才可以第一次直接请求数据)
            that.$refs.gridDrages.getTreeDatas(i);
          }

        } 
        if (item.type === 'detailed') {
          await that.$refs.gridDrages.getNewFromDatas(JSON.parse(JSON.stringify(i)), item);
        } else if (item.type === 'summary') {
          if (!item.devArticle) item.devArticle = 25;
          if (!item.devCurpage) item.devCurpage = 1;
          await that.$refs.gridDrages?.getSummaryTable(JSON.parse(JSON.stringify(i)), item, 1);

        } else if (item.type === 'indicatorsBread') {
          if (!item.devArticle) item.devArticle = 25;
          if (!item.devCurpage) item.devCurpage = 1;
          await that.$refs.gridDrages.getIndicatorsDetailsTable(JSON.parse(JSON.stringify(i)), item, 1);

        } else if (item.type === 'container' && item.children.length > 0 && item.children[item.selected] && item.children[item.selected].children && item.children[item.selected].children.length > 0) {
          // 如果是容器，加载当前容器加载的那个
          const a = item.children[item.selected].children[0]
          console.log('查看下家', that.$refs.gridDrages, this.$refs.gridDrages.layout)
          const ind = this.$refs.gridDrages.$data.layout.findIndex(its => its.i === (a.i || a))
          if (ind !== -1) {
            const ites = this.$refs.gridDrages.$data.layout[ind]
            if (ites.type === 'summary' || ites.type === 'indicatorsBread') {
              if (!ites.devArticle) ites.devArticle = 25;
              if (!ites.devCurpage) ites.devCurpage = 1;
            }
            if (ites.type === 'detailed') await that.$refs.gridDrages.getNewFromDatas(JSON.parse(JSON.stringify(ind)), ites);
            if (ites.type === 'summary') await that.$refs.gridDrages.getSummaryTable(JSON.parse(JSON.stringify(ind)), ites, 1);
            if (ites.type === 'indicatorsBread') await that.$refs.gridDrages.getIndicatorsDetailsTable(JSON.parse(JSON.stringify(ind)), ites, 1);
          }
        }
      }
      

    },
    //- 筛选组件。如果是要去它所关联的表添加所属规则（该方法只在页面加载完成后调用一次）
    screeningSeparation (datas) {
      //- 获取到筛选规则
      let pushdatas = screeningRules(datas);
      //- 记录要添加的表格
      let List = [];
      datas.sourceDatas.forEach(item => {
        //- 循环以获取当前组件的关联表，用id拿来查询
        if (item.isChecked === true) {
          List.push({
            i: item.i,
            appId: item.appId,
            reName: item.reName
          })

        }
      })
      return {
        rulesDatas: pushdatas,
        listDatas: List
      }


    },

    //- 新增：关联表单功能解析设置内容
    relevanceRulesFun (date) {
      console.log('新增：关联表单功能解析设置内容',date)
      let rules = [];
      date.relevance.forEach(item => {
        let fiterDatas = [];
        // 条件遍历
        if (item.linked && item.linked.length > 0) {
          for (const i of item.linked) {
            const obs = {
              fieldName: date.type === 'detailed' ? i.conditionValue : i.revisabilityName,
              title: date.type === 'detailed' ? i.conditionValue : i.revisabilityName,
              value: [],
              relation: fileWhere(i).relation || i.condition,
              matchName: i.name
            }
            if (item.link === 2) {
              const index = i.FormList.findIndex(its => its.name === i.conditionValue)
              if (index !== -1) {
                const tra = i.FormList[index]
                console.log('target数据', tra)
                if (tra.type === 'Sizer') continue
                obs.target = (tra.title || '') + '_' + tra.type
              }
            }
            fiterDatas.push(obs)
          }
        }
        // 自定义条件遍历
        console.log('自定义条件', item.customize)
        if (item.customize && item.customize.length > 0) {
          for(const i of item.customize) {
            console.log('值', i)
            const obs = {
              fieldName: i.name,//- 为了管理触发数据管理对比回填的key匹配
              title: i.submitName,
              value: [],
              relation: i.condition,
              comparisonValue: i.value,
              type: i.type,
              matchName: i.name
            }
            if (i.format) obs.format = i.format
            if (item.link === 2) {
              const index = i.FormList.findIndex(its => its.name === i.conditionValue)
              if (index !== -1) {
                const tra = i.FormList[index]
                console.log('target数据1', tra)
                obs.target = tra.title + '_' + tra.type
              }
            }
            fiterDatas.push(obs)
          }
        }
        if (!fiterDatas || fiterDatas.length === 0) return
        let pushDatas = {
          triggerId: date.i,
          // formid: item.link === 2 ? item.id : item.appid,
          formid: item.link === 2 ? item.appid : item.id,
          datas: [...fiterDatas],
          link: item.link,
          i: item.id
        }
        if (item.link === 2) {
          pushDatas.i = item.id
        }
        rules.push(pushDatas)

      })
      return rules;



    },
    //- 第二次进来后展示数据用
    secondShow (id) {
      const that = this;
      const obj = { approvalDashboardId: id }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      axiosBase(obj, "/api/getapprovaldashboard").then(async res => {
        if (res.code === 0 && res.data.config != "") {
          let config = JSON.parse(res.data.config);
					this.seriesType = config[0].seriesType || 'value'
					console.log(this.seriesType,'系列类型');
          // 删掉保存时添加的搜索
          config = config.filter(ite => {
            if (ite.type !== 'Sizer' || !ite.isContainer) return ite
          })
          // that.submitDataAlls.config = config;
          that.submitDataAlls.appname = res.data.appname;
          that.submitDataAlls.approvalDashboardId = res.data.approvalDashboardId;
          if (res.data.styleTemp) {
            this.styleTemp = JSON.parse(res.data.styleTemp);
          }
          if (res.data.variableconfig) {
            const { pc } = JSON.parse(res.data.variableconfig)
            const customData = await this.setParams({ customData: pc }, null, true)
            // 设置默认值
            if (this.search && customData.length > 0) {
              for (let key in this.search) {
                customData.forEach(item => {
                  if ((key === item.title + '_' + item.type) || key === item.title) {
                    const val = this.search[key]
                    if (item.type === 'date') {
                      if(item.type2 === 'range') {
                        item.value = Array.isArray(val) ? val : [val, val]
                      } else {
                        item.value = Array.isArray(val) && val.length > 0 ? val[0] : val
                      }
                    } else {
                      item.value = val
                    }
                  }
                })
              }
            }
            this.$store.commit('changeCustomData', { key: 'dashboard', value: customData });
            this.$store.commit('changeDashboardCustomDataObj', { id: this.approvalReportId, value: customData });
          } else {
            this.$store.commit('changeCustomData', { key: 'dashboard', value: [] });
          }
          let new_config = JSON.parse(JSON.stringify(config));
          let index = ''
          for (let i = 0; i < config.length; i++) {
            const item = config[i]
            if (this.search) {
              if (this.search.i) {
                if (Number(item.i) === Number(this.search.i)) {
                  index = i
                  new_config[i].viewShow = false
                } else {
                  new_config[i].viewShow = true
                }
              }
              // 如果存在 showSearch 就手动判断 i 改值
              if ((this.customDeskInfo.showSearch || this.$route.query.showSearch) && this.search[item.i]) {
                let val = this.search[item.i]
                if (item.activeName === 'text' && (typeof val === 'object' && val.userId || Array.isArray(val) && val[0] && val[0].userId)) {
                  val = Array.isArray(val) ? val.map(it => it.realname) : val.realname
                }
                // 如果val 的值属于联系人类型的值，则需要根据选择的输入方式做一下数据兼容
                new_config[i].FilterValue = Array.isArray(val) ? val : [val]
                item.FilterValue = Array.isArray(val) ? val : [val]
              }
            }
            //- 判断有没有筛选组件(前端模式)
            //- 判断是否是新增筛选组件。如果是要去它所关联的表添加所属规则
            const customDataList = this.$store.state.dashboardCustomDataObj[this.approvalReportId] || this.$store.state.dashboardCustomData
            if (item.type === 'Sizer' && !item.isContainer) {
              // 绑定字段存在则去查询具体值
              if (item.bindField && (!this.search || !this.search[item.i])) {
                if (item.bindField[0] === '$') {
                  let val = getFilterBindField(item.bindField, cloneDeep(customDataList))
                  if (val) {
                    let data
                    if (Array.isArray(val)) {
                      data = val.filter(item => { return item || item === 0 })
                    } else if (typeof val === 'object') {
                      data = [val]
                    } else {
                      data = typeof val === 'number' ? [val] : val.split(',')
                    }
                    new_config[i].FilterValue = data
                    item.FilterValue = data
                  }
                } else {
                  const res = await getapprovalbindval({feild: item.bindField}).catch(err => { console.log(err) })
                  if (res.code === 0) {
                    new_config[i].FilterValue = [res.data]
                    item.FilterValue = [res.data]
                    // 如果是横纵展开 并 是 自定义或数据字典，则把绑定值添加进去
                    if (item.FilterField.type !== 'relation-user' && item.FilterField.type !== 'date' && item.expandStyle && item.expandStyle !== 'stop' && (item.activeName === 'customize' || item.activeName === 'dictionary')) {
                      if (!item.FilterCustomize.includes(res.data)) {
                        new_config[i].FilterCustomize.push(res.data)
                        item.FilterCustomize.push(res.data)
                      }
                    }
                  }
                }
              }

              if (item.FilterValue && item.FilterValue.length > 0) {
                item.FilterValue = getFilterValue(item.FilterValue, cloneDeep(customDataList))
                new_config[i].FilterValue = cloneDeep(item.FilterValue)
              }
              // 联系人控件，有设置组织部门需要根据选择的组织部门获取到具体人员给到搜索
              if (item.FilterField.type === 'relation-user') {
                if (item.organize && item.organize.length > 0 || item.synchronousOrg) {
                  if (item.synchronousOrg) {
                    const userRes = await getdeptlist({
                      pid: -1,
                      curpage: 0,
                      pagesize: 0
                    })
                    if (userRes.code === 0) {
                      const redata = userRes.data.map(its => {
                        return {
                          name: its.name,
                          organizationId: its.organizationId
                        }
                      })
                      item.organize = redata
                      new_config[i].organize = redata
                    } else {
                      // 写死的 [999999999] 有问题问欧，开发不管
                      item.organize = [999999999]
                      new_config[i].organize = [999999999]
                    }
                  }
                  new_config[i].FilterValue = item.organize[0] ? [item.organize[0]] : []
                  item.FilterValue = item.organize[0] ? [item.organize[0]] : []
                }
              } else if (item.FilterField.type === 'date') {
                let val = ''
                if (item.FilterField.conditionValue && item.FilterField.conditionValue[0] === '$') {
                  val = getFilterValue(item.FilterField.conditionValue, cloneDeep(customDataList))
                  if (val && val[0]) {
                    // 时间就要这样的格式
                    val = [ val[0] + ' 00:00:00', val[0] + ' 23:59:59' ]
                  }
                  new_config[i].datePickerValue = val
                  item.datePickerValue = val
                }
              }

              if (item.skeletonLoading === true) {
                new_config[i].skeletonLoading = false;
              }
              //- 前台时筛选组件设定规则统计
              let rulesObj = that.screeningSeparation(item);
              const datas = item.FilterField.datas
              for (let i in rulesObj.listDatas) {
                for (let j in new_config) {
                  //- 说明是关联的表源，更新关联的表的筛选规则

                  if (rulesObj.listDatas[i].appId == new_config[j].appId && rulesObj.listDatas[i].i == new_config[j].i) {
                    // 找到过滤掉字段
                    const filterData = datas.find(iten => { return iten.i === rulesObj.listDatas[i].i})
                    let isCustom = false
                    let filed
                    if (filterData) {
                      filed = filterData.allDatas[filterData.checkValue]
                      if (filed && filed.datatype === 'custom') {
                        isCustom = true
                      }
                    }
                    if (!isCustom) {
                      if (new_config[j].rules == undefined) {
                        new_config[j].rules = [];
                      }
                      new_config[j].rules.push(rulesObj.rulesDatas);
                    } else {
                      // 过滤的字段是工坊的变量
                      const index = new_config[j].variableconfig.findIndex(iten => { return iten.name === filed.name })
                      if (index !== -1) {
                        new_config[j].variableconfig[index].value = rulesObj.rulesDatas.value
                      }
                    }

                  }
                }
              }

              //- 产品新增需求：缩小的文本组件点击才请求数据
              if (['status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(item.FilterField.type) !== -1
                && item.activeName === 'select') {
                //   && item.w <= 4 && item.h <= 22

                if (item.w >= 4 && item.h >= 22) {
                  //- 无需处理
                } else {
                  //- 准备点击请求筛选数据参数
                  that.$set(new_config[i], 'isAccomplish', false)
                }

              }

            } else if (item.type === 'detailed' || item.type === 'summary' || item.type === 'indicatorsBread') {
              new_config[i].skeletonLoading = true;//- 开启骨架屏
              if (!item.btnLimitStatus) {
                new_config[i].btnLimitStatus = false;
              }
              if (JSON.stringify(that.VerAndInputDatas) != '[]' && that.VerAndInputDatas.querys) {
                //- 添加仪表盘验证过滤后的参数数据
                new_config[i].querys = that.VerAndInputDatas.querys
              }
              //- 汇总表、指标图、饼图新增关联表单内容
              // if (item.type === 'summary' || item.type === 'indicatorsBread' || item.type === 'detailed') {
              if (item.relevance && item.relevance.length > 0) {
                //- 说明有关联表单设置数据
                let relevanceRules = that.relevanceRulesFun(JSON.parse(JSON.stringify(item)));//- 获取到当前这张表所关联对应表的规则
                console.log('获取关联', relevanceRules, new_config)
                relevanceRules.forEach((relevanceItem) => {
                  // 找对应点击配置
                  let findIndex = new_config.findIndex((findItem) => {
                    // console.log('关联排查', relevanceItem, findItem, relevanceItem.link === 2 ? relevanceItem.formid : relevanceItem.i, findItem.i)
                    return relevanceItem.i == findItem.i
                    // return (item.link === 2 || !item.link ? relevanceItem.formid : relevanceItem.i) == findItem.i
                  })
                  console.log('获取关联1', findIndex, relevanceItem)

                  if (findIndex != -1) {
                    //- 找到对应要添加的表
                    if (!new_config[findIndex].relevanceRules || new_config[findIndex].relevanceRules == undefined) {
                      new_config[findIndex].relevanceRules = [];
                    }

                    new_config[findIndex].relevanceRules.push(JSON.parse(JSON.stringify(relevanceItem)));
                  }
                })
              }
              // }
              // 工具条筛选组件默认值
              console.log('明细等数据查询', item)
              if (item.toolbar && item.toolbarConfig && item.toolbarConfig.length > 0) {
                for (let ai = 0; ai < item.toolbarConfig.length; ai++) {
                  const a = item.toolbarConfig[ai]
                  if (a.type === 'screen') {
                    console.log('工具条默认值赋值', a)
                    // 传参赋值
                    if ((this.search && this.search[a.i]) || this.paramsSearch[a.i]) {
                      const val = this.search && this.search[a.i] ? this.search[a.i] : this.paramsSearch[a.i]
                      a.FilterValue = val.map(item => { return item.name || item.realname || item })
                    }
                    if (a.bindField) {
                      if (a.bindField[0] === '$') {
                        let data = getFilterBindField(a.bindField, cloneDeep(customDataList))
                        if (data) {
                          a.FilterValue = data
                          item.toolbarConfig[ai].FilterValue = data
                          new_config[i].toolbarConfig[ai].FilterValue = data
                        }
                      } else {
                      const {code, data} = await getapprovalbindval({feild: a.bindField}).catch(err => { console.log(err) })
                        if (code === 0) {
                          a.FilterValue = [data]
                          item.toolbarConfig[ai].FilterValue = [data]
                          new_config[i].toolbarConfig[ai].FilterValue = [data]
                        }
                      }
                    }
                    // 数据源里面的变量
                    if (a.isCustom && Array.isArray(item.variableconfig)) {
                      a.datas.push(...item.variableconfig)
                    }
                    // 时间的默认值兼容
                    const datas = this.filterDatas(a.datas || [])
                    if (a.conditionValue && (a.checkValue || a.checkValue === 0) && datas[a.checkValue] && datas[a.checkValue].type === 'date') {
                      if (a.conditionValue === 'between') {
                        a.FilterValue = a.datePickerValue
                        new_config[i].toolbarConfig[ai].FilterValue = a.datePickerValue
                      } else {
                        let val = ''
                        if (a.conditionValue && a.conditionValue[0] === '$') {
                          val = getFilterValue(a.conditionValue, cloneDeep(customDataList))
                          if (Array.isArray(val)) {
                            // 时间就要这样的格式
                            val = val.length > 0 ? val : []
                            new_config[i].toolbarConfig[ai].conditionValue = 'between'
                          } else {
                            val = [val, val]
                          }
                        } else {
                          val = getTimeInstrument(a.conditionValue)
                        }
                        if (a.isCustom && !['thatDay','yesterday'].includes(a.conditionValue)) {
                          new_config[i].toolbarConfig[ai].FilterValue = val
                        }
                        // 如果筛选字段不是变量就用这个
                        if (!a.isCustom && Array.isArray(val)) {
                          val = val.map((iten, index) => {
                            return this.convertToFullDateTime(iten, index === 0 ? '00:00:00' : '23:59:59')
                          })
                        }
                        a.FilterValue = val
                        a.value = val
                        new_config[i].toolbarConfig[ai].value = val
                      }
                    }
                    // 如果有默认值就直接做结构并赋值过去
                    if (a.FilterValue && a.FilterValue.length > 0) {
                      // 如果是变量 改变变量的值就行
                      if (a.isCustom) {
                        const variableconfig = new_config[i].variableconfig || []
                        const name = a.customName || a.checkName
                        const index = variableconfig.findIndex(iten => { return iten.name === name })
                        if (index !== -1) {
                          let val = getFilterValue(a.FilterValue, cloneDeep(customDataList))
                          if (variableconfig[index].type === 'date') {
                            val = Array.isArray(val) ? val : [val, val]
                            // 后台说日期不需要时分秒（获取时间那边先不改 不确定会不会有别的问题）
                            val = val.map(iten => {
                              var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(iten)
                              if (newDate) {
                                iten = newDate[0]
                              }
                              return iten
                            })
                            if (variableconfig[index].type2 !== 'range') {
                              val = val[0]
                            }
                          } else if (['organization', 'roule', 'relation-user'].includes(variableconfig[index].type)) {
                            new_config[i].toolbarConfig[ai].FilterValue = val
                            new_config[i].toolbarConfig[ai].value = val
                          } else {
                            val = Array.isArray(val) ? val.join() : val
                          }
                          new_config[i].variableconfig[index].value = val || ''
                        }
                        // 存在第二个值
                        if (a.customName2) {
                          const name = a.customName2
                          const index = variableconfig.findIndex(iten => { return iten.name === name })
                          if (index !== -1) {
                            let val = a.FilterValue
                            if (variableconfig[index].type === 'date') {
                              val = Array.isArray(val) ? val : [val, val]
                            } else {
                              val = Array.isArray(val) ? val.join() : val
                            }
                            if (variableconfig[index].type === 'date') {
                              // 后台说日期不需要时分秒（获取时间那边先不改 不确定会不会有别的问题）
                              val = val.map(iten => {
                                var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(iten)
                                if (newDate) {
                                  iten = newDate[0]
                                }
                                return iten
                              })
                              if (variableconfig[index].type2 !== 'range') {
                                val = val[1]
                              }
                            }
                            new_config[i].variableconfig[index].value = val
                          }
                        }
                      } else {
                        const value = getFilterValue(a.FilterValue, cloneDeep(customDataList))
                        new_config[i].toolbarConfig[ai].FilterValue = value
                        const obe = {
                          filterId: a.i,
                          title: a.newDataName || a.checkName,
                          value: value,
                          relation: a.screenType === 'date' && Array.isArray(value) && value.length > 1 ? 'between' : a.activeName ? (a.activeName !== 'text' ? 'in' : 'like') : 'like'
                          // relation: a.activeName ? (a.activeName !== 'text' ? 'in' : 'like') : 'like'
                        }
                        item.rules.push(obe)
                        new_config[i].rules.push(obe)
                      }
                    } else if (a.value) {
                      if (typeof a.value === 'object' && a.value.datatype === 'custom') {
                        a.value = getFilterValue('$' + a.value.name, cloneDeep(customDataList))
                        new_config[i].toolbarConfig[ai].value = Array.isArray(a.value) ? a.value[0] : a.value
                      }
                      // 筛选字段是变量就不用进到筛选列表里面
                      if (a.isCustom) {
                        const variableconfig = new_config[i].variableconfig || []
                        const name = a.customName || a.checkName
                        const index = variableconfig.findIndex(iten => { return iten.name === name })
                        if (index !== -1) {
                          const val = Array.isArray(a.value) ? a.value.join() : a.value
                          new_config[i].variableconfig[index].value = val
                        }
                      } else {
                         let value = Array.isArray(a.value) ? a.value : [a.value]
                          const obe = {
                            filterId: a.i,
                            title: a.newDataName || a.checkName,
                            value: value,
                            relation: a.activeName ? (a.activeName !== 'text' ? 'in' : 'like') : 'like'
                          }
                          item.rules.push(obe)
                          new_config[i].rules.push(obe)
                      }

                    }
                  }
                }
              }
            }
          }
          if (index !== '') {
            new_config[index].rules = this.search.rules
            new_config[index].relevanceRules = this.search.relevanceRules
          }
          if (that.$refs.gridDrages) {
            that.$refs.gridDrages.layout = new_config;
          }
          // 初始化再给一个值表示（因为初始化不加载容器里面除了显示那个的数据）
          await that.getFormOrUpdateSize(new_config, true);
          this.isLoading = false
        } else {
          this.isLoading = false
          if (res.code === 8888){
            that.$message.error('您还未开通会员，请先开通');
            this.vipPayShow = true
          } else {
            that.$message.error('暂无权限访问，请联系管理员');
          }
        }
      })
    },
    filterDatas (datas = []) {
      const filterTitle = ['商户订单号', '支付状态', '支付订单号', '预支付状态']
      let arr = datas.filter(item => { return !filterTitle.includes(item.title) })
      return arr
    },
    convertToFullDateTime(dateString, time = '00:00:00') {
      // 验证格式和有效性
      const formatRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
      if (!formatRegex.test(dateString)) return dateString;

      const [year, month, day] = dateString.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
          return dateString; // 日期无效
      }

      // 格式化
      const pad = (n) => n.toString().padStart(2, '0');
      return `${year}-${pad(month)}-${pad(day)} ${time}`; // 默认时间00:00:00
    },
    //- 导航栏返回回调
    goback () {
      this.$router.go(-1)
    },
    styleClassFun () {
      let str = '.left-input-input input{background:#F7F7F7;border-color:transparent;}';/* +
                '.drageBlock {width: 148px;text-align: center;height: 36px;line-height: 36px;border: 1px solid blue;position: absolute;z-index: 1 !important;}';*/
      return returnAllTopStyle(str);
    }
  }
}
</script>

<style lang='scss' scoped>
.revise {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
:deep(.noSuccess) {
  background: transparent;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    background: transparent;
  }
}
.report :deep(.w-e-text-container) {
  height: auto !important;
  min-height: 235px !important;
}
.report {
  height: 100%;
  .center {
    display: flex;
    align-items: self-start;
    height: 100%;
    background-color: #ffffff;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .right {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .right-drage {
      width: 100%;
      height: 100%;
      max-width: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      &.hide {
        overflow-y: hidden !important;
      }
      .grid-box {
        transform-origin: left top;
        
      }
    }
  }
}
</style>
